import React, {useEffect} from 'react';
import PropTypes from 'prop-types';
import {useHistory} from 'react-router-dom';

import useQueryCustom from '@utils/hooks/useQueryCustom';
import Table from '@appComponents/Table';
import {GetMappedIsoCodes} from '@graphql/country/query';
import {getTableRowIsDisabledClassName} from '@modules/booking/utils/bookingsTable';
import {adjustHeight} from '@modules/client/utils/adjustHeightHelper';
import {ClientBookingsColumns} from '@modules/client/components/ClientBookings/Table/ClientBookingsColumns';
import {ClientBookingAndOfferingRowRenderer} from '@modules/client/components/ClientBookings/Table/ClientBookingAndOfferingRowRenderer';

const ClientBookingsTable = (props) => {
    const {cellRefs, clientBookings, clientId, getSelectedElements, loading, url} = props;
    const history = useHistory();

    const {data: {mappedIsoCodes} = {}, loading: loadingIsoCodes} = useQueryCustom({
        query: GetMappedIsoCodes,
    });

    useEffect(() => {
        adjustHeight(cellRefs);
    }, [cellRefs]);

    return (
        <div className='clientBookings__table'>
            <Table
                adjustHeight={adjustHeight}
                className='mini'
                columns={ClientBookingsColumns}
                data={clientBookings}
                defaultSort={'start_datetime'}
                showLimitWarning={true}
                dataLimitWarning={10000}
                loading={loading || loadingIsoCodes}
                name='clientBookingsList'
                noDataText='No bookings found'
                padded={false}
                rowRenderer={ClientBookingAndOfferingRowRenderer}
                rowRendererProps={{
                    mappedIsoCodes,
                    clientId,
                    history,
                    type: 'booking',
                }}
                rowClassname={getTableRowIsDisabledClassName}
                multiple={true}
                selectable={true}
                getSelectedElements={getSelectedElements}
                url={url}
            />
        </div>
    );
};

ClientBookingsTable.propTypes = {
    cellRefs: PropTypes.array,
    clientBookings: PropTypes.array,
    clientId: PropTypes.number.isRequired,
    data: PropTypes.shape({
        mappedIsoCodes: PropTypes.shape({
            countries: PropTypes.object,
            subdivisions: PropTypes.object,
        }),
    }),
    loading: PropTypes.bool.isRequired,
    getSelectedElements: PropTypes.func,
    url: PropTypes.string,
};
ClientBookingsTable.defaultProps = {
    clientBookings: [],
};

ClientBookingsTable.displayName = 'ClientBookingsTable';

export default ClientBookingsTable;
